import React, { ReactElement, useLayoutEffect, useState } from 'react';
import { Navigate, NavigationType, Router as ReactRouter, Route, Routes } from 'react-router-dom';
import Borrow from '@/Borrow/router';
import ScrollToTop from '@/ScrollToTop';
import history from '@/history';
import type { Update } from 'history';

export default function Router(): ReactElement {
    const [ browserState, setBrowserState ] = useState({
        action: history.action,
        location: history.location,
    });

    /*
     *  must use useLayoutEffect as this loads and registers history before paint
     */
    useLayoutEffect(() => {
        return history.listen((historyUpdate: Update) => {
            setBrowserState({ action: historyUpdate.action, location: historyUpdate.location });
        });
    }, []);

    return (
        <ReactRouter
            location={browserState.location}
            navigationType={browserState.action as NavigationType}
            navigator={history}
        >
            <ScrollToTop />
            <Routes>
                <Route element={<Borrow />} path='/get-your-quote/*' />
                <Route element={<Navigate to='/get-your-quote' />} path='/*' />
            </Routes>
        </ReactRouter>
    );
};

